import axios, { AxiosInstance } from 'axios';

const axiosInstance: AxiosInstance = axios.create({
   // baseURL: 'http://localhost:3000/'
    baseURL: 'https://ljns.fr:8565/'
});

export default axiosInstance;
